import { MailIcon, PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { matchesQuery } from '@/shared/lib/strings';
import type { CommandItem } from '@/shared/registry/types';

import { useCalendarCounters } from './api';
import { useOpenNewEvent } from './hooks';

/**
 * ⌘K actions: "New event" and "Invitations", while the query is empty or names them. The source id is not the module
 * id, so the palette's live search hits still list events (MODULE-CONTRACTS §5).
 */
export function useCalendarCommands(query: string): { items: CommandItem[] } {
  const { t } = useTranslation('calendar');
  const openNew = useOpenNewEvent();
  const pending = useCalendarCounters().data?.invitations ?? 0;
  const items: CommandItem[] = [
    {
      id: 'calendar:new',
      label: t('actions.newEvent'),
      icon: PlusIcon,
      keywords: [t('page.title'), 'event', 'meeting', 'событие', 'встреча', 'подія', 'зустріч'],
      perform: () => openNew(),
    },
    {
      id: 'calendar:invitations',
      label: t('invitations.title'),
      description: pending > 0 ? t('invitations.link', { count: pending }) : undefined,
      icon: MailIcon,
      keywords: [t('page.title'), 'invitations', 'приглашения', 'запрошення'],
      to: '/calendar/invitations',
    },
  ];
  return { items: items.filter((item) => matchesQuery(query, item.label, ...(item.keywords ?? []))) };
}
